import React, { FC } from 'react';
import { Box, Divider, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import { PinIcon } from 'svgs/projects';
import clsx from 'clsx';

export interface ProjectModalContentProps {
  address: string;
  title: string;
  image: string;
  description: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  address: {
    fontWeight: 500,
    paddingLeft: theme.spacing(4.5),
  },
  textBlock: {
    padding: theme.spacing(0, 4),
    maxHeight: '100%',
    minHeight: 400,
    position: 'relative',
    order: 2,
    [theme.breakpoints.up('md')]: {
      order: 1,
    },
    [theme.breakpoints.up('lg')]: {
      maxHeight: 400,
    },
  },
  icon: {
    position: 'absolute',
    top: theme.spacing(0),
    left: theme.spacing(4),
  },
  title: {
    fontWeight: 500,
    color: theme.palette.primary.dark,
    marginBottom: theme.spacing(3),
  },
  description: {
    lineHeight: 1.8,
    paddingBottom: theme.spacing(3),
    overflowY: 'auto',
    height: 230,
  },
  imageBlock: {
    position: 'relative',
    order: 1,
    [theme.breakpoints.up('md')]: {
      order: 2,
    },
  },
  imageWrapper: {
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    width: '100%',
    height: '100%',
    minHeight: 215,
  },
  divider: {
    maxWidth: 420,
    backgroundColor: theme.palette.secondary.light,
  },
}));

const ProjectModalContent: FC<ProjectModalContentProps> = (props) => {
  const { address, image, description, title } = props;
  const classes = useStyles();

  return (
    <Grid container direction={'row'} justifyContent="space-between">
      <Grid xs={12} md={6} className={classes.textBlock} item>
        <Grid container direction="column" style={{ minHeight: '100%' }} justifyContent="space-between">
          <Grid item>
            {address && (
              <>
                <PinIcon className={classes.icon} />
                <Typography variant="body1" color="textSecondary" className={classes.address}>
                  {address}
                </Typography>
                <Box mt={3} mb={4}>
                  <Divider className={classes.divider} />
                </Box>
              </>
            )}
            <Typography variant="h5" className={classes.title}>
              {title}
            </Typography>
            <Typography
              variant="body1"
              color="textSecondary"
              className={classes.description}
              dangerouslySetInnerHTML={{ __html: description }}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid xs={12} md={6} className={clsx(classes.imageBlock)} item>
        <Box className={classes.imageWrapper} style={{ backgroundImage: `url("${image}")` }} />
      </Grid>
    </Grid>
  );
};

export default ProjectModalContent;
